import CalendarsDialog from './CalendarsDialog';

export default CalendarsDialog;
